import { render } from "./MainComponent.vue?vue&type=template&id=5194b434&scoped=true&ts=true"
import script from "./MainComponent.vue?vue&type=script&lang=ts"
export * from "./MainComponent.vue?vue&type=script&lang=ts"

import "./MainComponent.vue?vue&type=style&index=0&id=5194b434&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5194b434"]])

export default __exports__